import {
  GridColDef,
} from "@mui/x-data-grid";

export function getDate(date: string | undefined): Date | null {
  if (!date) return null;

  // Handle DD-MM-YYYY format and convert to YYYY-MM-DD
  if (/^\d{2}-\d{2}-\d{4}$/.test(date)) {
    date = date.split("-").reverse().join("-");
  }

  const parsedDate = new Date(date);
  return isNaN(parsedDate.getTime()) ? null : parsedDate;
}

// Grid columns definition
export const gridColumns: GridColDef[] = [
  {
    field: "id",
    headerName: "Arrow ID",
    flex: 1,
    type: "string",
    filterable: false
  },
  {
    field: "externalInvoiceId",
    headerName: "Invoice number",
    flex: 1,
    type: "string",
    filterable: false
  },
  {
    field: "assignedTo",
    headerName: "Assigned to",
    editable: true,
    flex: 1,
    type: "string",
    filterable: false
  },
  {
    field: "supplierName",
    headerName: "Supplier name",
    editable: true,
    flex: 1,
    type: "string",
    filterable: false
  },
  {
    field: "supplierSite",
    headerName: "Supplier site",
    editable: true,
    flex: 1,
    type: "string",
    filterable: false
  },
  {
    field: "invoiceDate",
    headerName: "Invoice date",
    flex: 1,
    type: "date",
    filterable: false
  },
  {
    field: "glDate",
    headerName: "GL date",
    flex: 1,
    type: "date",
    filterable: false
  },
  {
    field: "invoiceAmount",
    headerName: "Invoice amount",
    flex: 1,
    type: "number",
    filterable: false
  },
  {
    field: "currency",
    headerName: "Currency",
    flex: 1,
    type: "string",
    filterable: false
  },
  {
    field: "queueName",
    headerName: "Worklist",
    flex: 1,
    type: "string",
    filterable: false
  },
  {
    field: "opcoName",
    headerName: "Business unit",
    flex: 1,
    type: "string",
    filterable: false
  },
];
